import React from "react";
import classNames from "classnames";
import styles from "./bopis-accordion-no-location-message.module.scss";
import {
  USER_COUNTRY_CA,
  NO_LOCATION_MESSAGE_US,
  NO_LOCATION_MESSAGE,
  CANT_FIND_LOCATION_MESSAGE
} from "./constants";
/**
 * @param {function} handleChangeLocations - A function to handle the change of the selected store location.
 * @param {string} userCountry - "US" or "CA"
 */
const BopisAccordionNoLocationMessage = ({
  handleChangeLocations,
  userCountry
}) => {
  const cantFindLocationButtonText =
    userCountry === USER_COUNTRY_CA
      ? NO_LOCATION_MESSAGE
      : NO_LOCATION_MESSAGE_US;

  return (
    <div className={styles.cantFindLocationMessage}>
      <p className={styles.cantFindLocationText}>
        {CANT_FIND_LOCATION_MESSAGE}
      </p>
      <button
        className={classNames("lll-link-primary", styles.locationBtn)}
        onClick={handleChangeLocations}
      >
        {cantFindLocationButtonText}
      </button>
    </div>
  );
};

export default BopisAccordionNoLocationMessage;
